/**
 * Returns the first element of an array, or `null` if the array is empty or undefined.
 *
 * @param array - The array to access.
 * @returns The first element, or `null`.
 *
 * @example
 * firstElement([1, 2, 3]); // 1
 * firstElement([]);        // null
 * firstElement(undefined); // null
 */
export function firstElement<T>(array: T[] | null | undefined): T | null {
  return array?.length ? array[0] : null;
}

/**
 * Returns the last element of an array, or `null` if the array is empty or undefined.
 *
 * @param array - The array to access.
 * @returns The last element, or `null`.
 *
 * @example
 * lastElement([1, 2, 3]); // 3
 * lastElement([]);        // null
 * lastElement(undefined); // null
 */
export function lastElement<T>(array: T[] | null | undefined): T | null {
  return array?.length ? array[array.length - 1] : null;
}
